<template>
  <div class="carousel-wrapper">
    <loader-component v-if="is_loading" />
    <div v-else class="p-t-10">
      <div :id="'carousel_component-' + data[0].id" class="carousel slide" data-ride="carousel" v-if="posts">
        <div class="carousel-inner">
          <div v-for="(post, idx) in posts" :key="idx" class="carousel-item p-l-30 p-r-30"
            :class="idx === 0 ? 'active' : ''">
            <div class="row">
              <div v-for="item in post" :key="item._id.$oid" :class="is_single ? 'col-md-3' : 'col-md-4'">
                <div class="card card-default border p-3 h-100" style="border-radius: 10px">
                  <center>
                    <div class="border shade" style="width: 100%; overflow: hidden; border-radius: 8px"
                      :style="is_single ? 'height:12rem' : 'height:7rem'">
                      <img v-if="item.source == 'news' || item.source == 'media_cetak'
                        " :src="item.thumbnail ? item.thumbnail : item.file_source ? item.file_source[0] : ''"
                        @error="imgError" style="height: 100%; width: 100%; align-self: center; object-fit: cover;"
                        class="shadow-sm" />
                      <video v-else-if="item.source == 'media_tv'" :src="item.file_source" style="
                          height: 100%;
                          width: 100%;
                          align-self: center;
                          object-fit: cover;
                        "></video>
                      <img v-else-if="item.source == 'youtube'" :src="item.thumbnail.default.url" @error="imgError" style="
                          height: 100%;
                          width: 100%;
                          align-self: center;
                          object-fit: cover;
                        " />
                      <div v-else class="w-100 h-100">
                        <div v-if="item.photo != null">
                          <center>
                            <img id="gambar" :src="item.photo" alt="Image Post" @error="imgError" style="
                                height: 100%;
                                width: 100%;
                                align-self: center;
                                object-fit: cover;
                              " />
                          </center>
                        </div>
                        <div v-else class="shade w-100" style="
                            border-radius: 8px;
                            height: 100%;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          ">
                          <i v-if="item.source" class="fa-3x" :class="sosmed_icon[item.source] + ' icon-' + item.source
                            "></i>
                        </div>
                      </div>
                    </div>
                  </center>
                  <div class="mt-2 mb-3 d-flex align-items-center" style="font-size: 12px">
                    <div>
                      <i v-if="item.source == 'media_tv'" class="bi bi-tv text-danger"></i>
                      <i v-else-if="item.source == 'media_cetak'" class="bi bi-newspaper"></i>
                      <i v-else-if="item.source == 'news'" class="bi bi-globe-americas text-success"></i>
                      <div v-else>
                        <i v-if="item.source" style="font-size: 12px" :class="sosmed_icon[item.source] + ' icon-' + item.source
                          "></i>
                      </div>
                    </div>
                    <span class="ml-1">{{ item.account }}</span>
                  </div>
                  <a v-if="item.source == 'media_cetak' || item.source == 'media_tv'
                    " href="javascript:void(0)" @click="showSumber(item)"
                    class="text-justify text-dark hoverable mb-2 title-format" style="font-size: 14px">
                    <strong>{{ titleFormatter(item.title) }}</strong>
                  </a>
                  <a v-else :href="item.url" target="_blank" class="text-justify text-dark hoverable mb-2 title-format"
                    style="font-size: 14px; font-weight: normal !important">
                    <strong>{{ titleFormatter(item.content) }}</strong>
                  </a>
                  <div style="font-size: 12px">
                    <i class="bi bi-calendar-event"></i>
                    {{ convertDate(item.date.$date) }}
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="is_single && idx == 1">
                <div class="card border p-3 h-100" style="
                    border-radius: 5px;
                    align-items: center;
                    justify-content: center;
                  ">
                  <a @click.prevent="target" to="#" class="hoverable clickable">
                    <center>
                      <i class="bi bi-arrow-right-circle" style="font-size: 50px"></i>
                      <br />
                      Lihat Semua
                    </center>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" style="width: 10%; opacity: 1" :href="'#carousel_component-' + data[0].id"
          role="button" data-slide="prev">
          <button class="btn btn-icon btn-success">
            <i class="bi bi-chevron-left"></i>
            <span class="sr-only">Previous</span>
          </button>
        </a>
        <a class="carousel-control-next" style="width: 10%; opacity: 1" :href="'#carousel_component-' + data[0].id"
          role="button" data-slide="next">
          <button class="btn btn-icon btn-success">
            <i class="bi bi-chevron-right"></i>
            <span class="sr-only">Next</span>
          </button>
        </a>
      </div>
      <div v-if="!posts" class="col-md-12 col-sm-12 col-lg-12">
        <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
          <strong>Mohon maaf, data tidak tersedia! </strong> <br />
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
    </div>
    <div v-if="posts && posts.length > 0 && !is_single" class="px-4 mt-3">
      <a @click.prevent="target" to="#">
        <button class="btn btn-warning btn-block">Lihat Semua</button>
      </a>
    </div>
    <modal-dynamic-component v-if="show_modal_sumber" :key="modal_sumber_key" modal_id="modal_sumber"
      :modal="modal_sumber" :data="modal_sumber_data" />
  </div>
</template>

<script>
import loader from "@/views/components/loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_sumber_body from "@/views/components/mention/modal_sumber.vue";
import moment from "moment";

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter-x";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["review"] = "bi bi-phone";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";

export default {
  name: "carousel_post_list",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    is_single: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  components: {
    "loader-component": loader,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      is_loading: false,
      sosmed_icon: sosmed_icon,
      posts: null,
      limit: this.data[0].limit ? this.data[0].limit : this.is_single ? 7 : 6,
      sort: this.data[0].sort,
      is_socmed: "is_socmed" in this.data[0] ? this.data[0].is_socmed : true,
      is_highlight:
        "is_highlight" in this.data[0]
          ? this.data[0].is_highlight
            ? true
            : false
          : false,
      id_project: this.$store.getters.user.id_project,
      modal_sumber: null,
      modal_sumber_data: null,
      modal_sumber_key: 10,
      show_modal_sumber: false,
      modal_sumber_body: modal_sumber_body,
    };
  },
  methods: {
    convertDate(tanggal) {
      return moment.utc(tanggal).format("D MMM YYYY HH:mm");
    },
    getData: function () {
      let params = this.$route.query;
      if (this.is_socmed === false) {
        params.sources = btoa("media_cetak,media_tv,news");
      } else {
        params.sources = btoa(
          "facebook,twitter,instagram,youtube,forum,blog,tiktok,linkedin"
        );
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      query += "&sort=" + this.sort + "&items=" + this.limit;
      let api;
      if (this.is_highlight) {
        api =
          process.env.VUE_APP_API_URL +
          "highlighted-posts/" +
          this.id_project +
          "?" +
          query;
      } else {
        api =
          process.env.VUE_APP_API_URL +
          "posts-dev/" +
          this.id_project +
          "?" +
          query;
      }

      delete params.sources;
      if ("from" in params && "to" in params) {
        this.is_loading = true;
        this.$http
          .get(api)
          .then((response) => {
            this.posts = this.divideArray(response.data.posts);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
    target: function () {
      let param = {
        from: this.$route.query.from,
        to: this.$route.query.to,
        sort: this.sort,
      };

      if (this.is_highlight) {
        param.highlight = 1;
      }

      param.sources = btoa(
        "facebook,twitter,instagram,youtube,forum,blog,tiktok"
      );
      if (this.is_socmed === false) {
        param.sources = btoa("media_cetak,media_tv,news");
      }

      this.$router.push({ path: "/posts", query: param });
    },
    showSumber: function (data) {
      this.modal_sumber = {
        title: "Sumber Data",
        subtitle: "",
        component: this.modal_sumber_body,
      };
      this.modal_sumber_data = [data];
      this.modal_sumber_key++;
      this.show_modal_sumber = true;
    },
    imgError: function () {
      event.target.src = "/assets/img/web/imgerror.png";
    },
    divideArray(array) {
      const result = [];
      const length = this.is_single ? 4 : 3;
      if (array) {
        for (let i = 0; i < array.length; i += length) {
          const chunk = array.slice(i, i + length);
          result.push(chunk);
        }
      }

      return result;
    },
    titleFormatter(val) {
      if (this.is_single) {
        if (val && val.length > 100) {
          return val.substring(0, 100) + "...";
        }
        return val;
      } else {
        if (val && val.length > 50) {
          return val.substring(0, 50) + "...";
        }
        return val;
      }
    },
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  created: function () {
    this.getData();
    this.titleFormatter();
  },
};
</script>

<style scoped>
.posts-item.propic-badge {
  top: 20px !important;
}

.card {
  margin-bottom: 2px !important;
}

.social-card {
  width: 100%;
  border-bottom: 0px !important;
}

.share .card-header {
  border-bottom: 0px !important;
}

.card-header {
  padding-bottom: 5px !important;
}

.card-description {
  padding-top: 0px !important;
}

.posts-item {
  overflow-y: scroll;
  height: 310px !important;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background: #a1d7fa;
  border: 0px none #ffffff;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #8bcefa;
}

::-webkit-scrollbar-thumb:active {
  background: #0f8ff9;
}

::-webkit-scrollbar-track {
  background: #eeeeee;
  border: 2px none #ff0000;
  border-radius: 23px;
}

::-webkit-scrollbar-track:hover {
  background: #ffffff;
}

::-webkit-scrollbar-track:active {
  background: #ffffff;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
</style>